module.exports = __webpack_public_path__ + "components/scroll-button/static/icon-chevron-circle-right-ba7fac90109d888ba52e34f9d1c063a6.svg";